import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

export const ModifierLanguageSelect = ({ options, field, form }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const languageOptions = options && options.length ?
        options.map(item=>(
            {
                value: item.value,
                label: item.item,
            }
        )) : []
    
    const customSelectStyles = {
        dropdownIndicator: (base) => ({ ...base, color: "#504DE2" }),
        menuList: (base) => ({ ...base, maxHeight: "full" }),
        input: (base) => ({ ...base, boxShadow: 'none !important',
        '*': {boxShadow: 'none !important',outline: 'none !important'}}),
    };

    let selectedCoutry = options
        ? options.find((option) => option.item === field.value)
        : "";

    const handleChange = (option) => {
        form.setFieldValue("language", option.item);
        // dispatch(onChangeModifierLanguage(option.value))
    };
    
    return (
        <Select
            options={languageOptions}
            name={field.name}
            value={selectedCoutry}
            defaultValue={languageOptions[0]}
            onChange={handleChange}
            onBlur={field.onBlur}
            placeholder={t("Select Language")}
            styles={customSelectStyles}
        />
    );
};
